import React from 'react';
import PropTypes from 'prop-types';

import HubModel from 'models/hub';
import Brand from 'models/brand';

import CityDetails from 'components/hub/city-details';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const Destinations = ({ hub, brand }) => {
  if (!hub.hasDestinations) { return null; }

  return (
    <div className="hub-destinations container bottom-shadow-blur">
      <CityDetails hub={hub} brand={brand} />
    </div>
  );
};

Destinations.propTypes = propTypes;

export default Destinations;
